// extracted by mini-css-extract-plugin
module.exports = {"customMenu":"MainNavigation_customMenu__12XG_"};